export function setMemberPaymentPlans(state, plans) {
  state.memberPaymentPlans = plans;
}

export function setCurrentPaymentPlan(state, plan) {
  state.currentPaymentPlan = plan;
}

export function setNextInstallment(state, installment) {
  state.nextInstallment = installment;
}
